import { all, put, takeEvery } from 'redux-saga/effects';
import * as Actions from '../timeZone/actions';
import { showToast } from '../notification';
import constants from '../../../../helpers/constant';
import fetchJSON from '../../../../helpers/fetchJSON';
import { TIMEZONE_INTEGRITY_KEY, TIMEZONE_SRC } from '../../../../components/TimeZoneSelector/constants';
import { setTimeZoneStatus, Status } from './actions';

function* loadTimeZones() {
  yield put(setTimeZoneStatus(Status.LOADING));
  const timeZoneData = yield fetchJSON(TIMEZONE_SRC, TIMEZONE_INTEGRITY_KEY);
  if (timeZoneData && !timeZoneData.error) {
    yield put(Actions.setTimeZones([...timeZoneData]));
  } else {
    yield put(setTimeZoneStatus(Status.ERROR));
    yield put(showToast({
      message: 'Time Zone error while verifying the file integrity',
      action: 'Dismiss',
      type: constants.FAILED
    }));
  }
}

export default function* timeZone() {
  yield all([
    takeEvery(Actions.ActionType.LOAD_TIME_ZONES, loadTimeZones)
  ]);
};
